
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/varmetab",
      function () {
        return require("private-next-pages/varmetab.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/varmetab"])
      });
    }
  